import priceAmountListTemplate from '/scripts/_partials/price-amount-list/templates/priceAmountList.html';
/* @ngInject */
function priceAmountListDirective() {
  return {
    restrict: 'A',
    scope: {
      productId: '=',
      offerId: '=',
      startOfferId: '=',
      initFn: '&'
    },
    controller: 'PriceAmountListCtrl',
    controllerAs: 'priceAmountList',
    bindToController: true,
    replace: true,
    templateUrl: priceAmountListTemplate
  };
}
export { priceAmountListDirective };